<template>
	<div class="row">
    <div class="col-md-12" style="display: block ruby;">
		  <h1 class="">FX Rate</h1>
      <b-button class="btn-lg btn-default pull-right" title="Add New Currency" @click="showAddNewCurrency"><i class="fa fa-plus"></i> Add New Currency</b-button>
    </div>
    
    <div class="col-sm-12">
      <div class="pull-right form-group">
        <label>FX Rate on </label><date-picker :disabled-date="disabledDates" input-class="form-control" ref="fx_date" value-type="format" v-model="tableData.fx_date" format='DD-MM-YYYY' readonly></date-picker>
        <div class="mt-4" style="display:flow-root;">
          <a href="javascript:;" class="pull-right" @click="showModal('upload-deal-ticket-out')" v-if="can_access('fxrate','upload')">Upload FX Rate CSV</a>
          <a href="javascript:;" class="pull-right mr-3" @click="recheck_fc()" v-if="can_access('fxrate','modify')">Recheck Financing Charges</a>
        </div> 
      </div>
      <div class="pull-right form-group mr-3">
        <label>Custodian </label>
          <b-input-group>
            <select name="type" ref="custodian" class="form-control" v-model="tableData.custodian_id">
              <option selected value=0>Default (Client)</option>
              <option selected value=1000>Default (Broker)</option>
              <option v-for="custodian in custodians" :key="custodian.id" :value="custodian.id">{{custodian.name}}</option>
            </select>
          </b-input-group>
      </div>
    </div>

		<TableView :col="columns" :getData="getData" v-if="!refreshView"/>

    <div class="col-sm-12" v-if="can_access('fxrate','modify')">
      <b-button class="btn btn-lg btn-info pull-right" title="Save FX rates" @click="addFXRates"><i class="fa fa-save"></i> Save</b-button>
    </div>

    <b-modal ref="add-currency-out" title="Add New Currency" size="xl" hide-footer v-if="showAddCurrencyForm && can_access('fxrate','modify')">
      <p class="my-4"><AddNewCurrencyForm :forceRerender="addNewCurrency"/></p>
    </b-modal>
    <b-modal ref="upload-deal-ticket-out" title="Upload FX Rate" size="xl" hide-footer v-if="can_access('fxrate','upload')">
      <p class="my-4"><UploadDealTicketForm @forceRerender="uploadMarketValueFormReRender" uri="import_fxrate" sample_file="fxrate_sample" note="*As like as in the sample file first column must be date, and for the further columns you can add/remove the new/existing currency code"/></p>
    </b-modal>
	</div>
</template>
<script>
import moment from 'moment';
import common from '@/assets/js/common.js';

export default {
  name: 'FXRatePage',
  components: {
    TableView : () => import('@/components/Common/DataTable/Table') ,
    DatePicker : () => import('vue2-datepicker') ,
    Widget : () => import('@/components/Widget/Widget') ,
    AddNewCurrencyForm: () => import('@/components/Accounts/AddNewCurrencyForm'),
    UploadDealTicketForm : () => import('@/components/Accounts/UploadTradesCSV')
  },
  mixins: [common],
  data() {
    return {
      showAddCurrencyForm: true,
    	tableData: {
        'fx_date': this.getLastWorkingDate(),
        'custodian_id': 0,
      },
      custodians: [],
      refreshView: false,
      errorMessage: null,

      columns: (() => {
        const cols = [
          { title: 'Currency Name (Base Currency : USD)', field: 'name', sortable: true },
          { title: 'Currency Code', field: 'code', sortable: true },
          { title: 'Value', field: 'value', sortable: true, tdComp: 'Input' },
          /* { title: 'Libor Rate', field: 'libor_rate', sortable: true, tdComp: 'Input' },
          { title: 'Spread Rate', field: 'spread_rate', sortable: true, tdComp: 'Input' }, */
          { title: 'Operation', tdComp: 'fxOpt', visible: this.can_access('fxrate','modify') }
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          if(!this.can_view_field('fxrate', col.nested?col.nested:col.field) && col.title != 'Operation') col.visible = false;
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
    };
  },
  watch: {
    'tableData.fx_date': function(newValue){
      if(moment(newValue,'DD-MM-YYYY').isBefore(moment())){
        this.refreshView = true;
        this.$nextTick(function(){
          this.refreshView = false;
        });
      }else{
        this.tableData.fx_date = moment().subtract(1, 'days').format("DD-MM-YYYY");
      }
    },
    'tableData.custodian_id': function(newValue){
      this.refreshView = true;
      this.$nextTick(function(){
        this.refreshView = false;
      });
    }
  },
  methods: {
    showModal(model) {
      this.$refs[model].show()
    },
    uploadMarketValueFormReRender(response){
      if(response.code==0){
          this.$refs['upload-deal-ticket-out'].hide()
          this.refreshView = true;
          this.$nextTick(function(){
            this.refreshView = false;
          });
      }
    },
    async getCustodian(){
      const {response} = await this.call_axios('get_custodians');
      this.custodians = response.data;     
    },
    async getData(query, filter) {
      const { limit = 10, offset = 0, sort = '', order = '' } = JSON.parse(JSON.stringify(query));
      filter['fx_date'] = this.tableData.fx_date;
      filter['custodian_id'] = this.tableData.custodian_id;
			let uri = 'getfxratecurrencies?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
			const res = await this.call_axios(uri);
			res.response.data.Pagination = false;
			//this.tableData = res.response.data.result;
      Object.assign(this.tableData, res.response.data.result);
			return res;
    },
    addFXRates: async function(){
      const {response} = await this.call_axios('add_fxrate', 'post', {data:this.tableData}); 
      this.$toasted.success("Successfully Added",{duration:1000});    
    },
    addNewCurrency: function(response){
      if(response.code==0){
          this.$refs['add-currency-out'].hide();
          this.refreshView = true;
          this.$nextTick(function(){
            this.refreshView = false;
          });
      }
    },
    disabledDates(date){
      if(moment(date).isAfter(moment())) return true;
      return false;
    },
    showAddNewCurrency(){
      this.$refs['add-currency-out'].show()
    },
    recheck_fc(){
      this.call_axios('auto_daily_charges');
    }
  },
  created() {
    this.getCustodian()
  },
};
</script>